module.exports = __webpack_public_path__ + "img/logo-website.7b48ae5d.jpeg";